import { COVERGO_SAAS_DEV } from "../consts.js"

export const salesTenant_dev = {
	"cover-health-sales-studio.quote.hk": {
		appConfig: {
			tenantId: "salesTenant_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
